module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/tender/tender-grid/tender-grid.component.css
// module id = ./src/app/technical/tender/tender-grid/tender-grid.component.css
// module chunks = main